// Loading skeleton for read-only detail pages (breadcrumb header, overview
// card with image + read-only fields, configurations card, footer). Keep in
// sync with Components::Skeletons::Details.

import {
  Bar,
  DetailFooter,
  DetailHeader,
  DEFAULT_LABEL,
  PageShell,
  ReadOnlyField,
  TwoColumnReadOnly,
} from './primitives';

export function DetailsSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <DetailHeader crumbs={2} />
      <div className="flex-1">
        <div className="w-full px-16 pt-8 pb-12 space-y-12">
          <section>
            <Bar className="h-[30px] w-32 mb-4" />
            <div className="flex gap-16 rounded-input border border-dinnerplate-white bg-off-white p-6">
              <Bar className="aspect-square w-preview-image shrink-0 rounded-input" />
              <div className="flex flex-1 flex-col gap-8">
                <ReadOnlyField />
                <TwoColumnReadOnly />
                <TwoColumnReadOnly />
              </div>
            </div>
          </section>
          <section>
            <Bar className="h-[30px] w-44 mb-4" />
            <div className="rounded-input border border-dinnerplate-white p-6">
              <div className="flex flex-col gap-8">
                <div className="flex gap-8">
                  <ReadOnlyField />
                  <ReadOnlyField />
                </div>
                <div className="flex gap-8">
                  <ReadOnlyField />
                  <ReadOnlyField />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <DetailFooter buttonClass="h-[45px] w-[64px]" />
    </PageShell>
  );
}
